import React, { useEffect, useState } from "react";
import Select from "react-select";
import "./CountryCode.css";

const CountryCode = ({
  onChange,
  label = "Country Code",
  placeholder = "Enter phone number",
  value = { countryCode: "+91", phone: "" }, // 👈 react-hook-form se aayega
}) => {
  const [countryOptions, setCountryOptions] = useState([]);
  useEffect(() => {
    const dummyData = [
      { name: "India", dial_code: "+91", code: "IN" },
      { name: "United States", dial_code: "+1", code: "US" },
      { name: "United Kingdom", dial_code: "+44", code: "GB" },
    ];
    const formattedOptions = dummyData.map((item) => ({
      label: `${item.name} (${item.dial_code})`,
      value: item.dial_code,
      code: item.code.toLowerCase(),
      flag: `https://flagcdn.com/24x18/${item.code.toLowerCase()}.png`,
    }));

    setCountryOptions(formattedOptions);
  }, []);

  const selectedCountry =
    countryOptions.find((opt) => opt.value === value.countryCode) ||
    countryOptions[0];

  const handleSelectChange = (selectedOption) => {
    onChange?.({ countryCode: selectedOption.value, phone: value.phone });
  };


  // Handles typed, pasted and autofilled numbers like "+91 98765 43210",
  // "0091...", "919876543210" or "09876543210" without mangling them.
  const handlePhoneChange = (e) => {
    const raw = String(e.target.value || "").trim();
    let countryCode = value.countryCode;
    let digits = raw.replace(/\D/g, "");

    if (raw.startsWith("+") || raw.startsWith("00")) {
      if (raw.startsWith("00")) digits = digits.slice(2);
      const match = countryOptions
        .map((opt) => opt.value)
        .sort((a, b) => b.length - a.length)
        .find((dial) => digits.startsWith(dial.slice(1)));
      if (match) {
        countryCode = match;
        digits = digits.slice(match.length - 1);
      }
    } else if (digits.length > 10) {
      const cc = String(countryCode || "").replace("+", "");
      if (cc && digits.startsWith(cc) && digits.length - cc.length <= 10) {
        digits = digits.slice(cc.length);
      }
    }

    // Drop trunk prefix (e.g. leading 0) and cap at 10 digits
    digits = digits.replace(/^0+/, "").slice(0, 10);

    onChange?.({ countryCode, phone: digits });
  };

  return (
    <div className="form-group country-select_group mb-3">
      {label && <label>{label}</label>}
      <div className="country-phone-wrapper">
        <div className="country-select-wrapper">
          <Select
            options={countryOptions}
            value={selectedCountry}
            onChange={handleSelectChange}
            classNamePrefix="country-custom-select"
            formatOptionLabel={(data, { context }) =>
              context === "menu" ? (
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <img
                    src={data.flag}
                    alt={data.code}
                    width={20}
                    height={15}
                    style={{ borderRadius: "2px", objectFit: "cover" }}
                  />
                  <span>{data.label}</span>
                </div>
              ) : (
                <span>{data.value}</span>
              )
            }
          />
        </div>
        <input
          type="tel"
          inputMode="numeric"
          autoComplete="tel"
          className="country-phone-input"
          placeholder={placeholder}
          value={value.phone}
          onChange={handlePhoneChange}
        />
      </div>
    </div>
  );
};

export default CountryCode;




















// import React, { useEffect, useState } from "react";
// import Select from "react-select";
// import "./CountryCode.css";
// import { api } from "../../../api/api";
// import { useAuthContext } from "../../../ContextAPI/AuthContextAPI";

// const CountryCode = ({ onChange, label = "Country Code", initialValue = "" }) => {
//   const { currUserData } = useAuthContext();
//   const [countryOptions, setCountryOptions] = useState([]);
//   const [selectedCountry, setSelectedCountry] = useState(null);
//   const [phone, setPhone] = useState(initialValue);

//   const getCountryCodes = async () => {
//     // future real API integration
//   };


//   useEffect(() => {
//     const dummyData = [
//       { name: "India", dial_code: "+91", code: "IN" },
//       { name: "United States", dial_code: "+1", code: "US" },
//       { name: "United Kingdom", dial_code: "+44", code: "GB" },
//     ];

//     const formattedOptions = dummyData.map((item) => ({
//       label: `${item.name} (${item.dial_code})`,
//       value: item.dial_code,
//       code: item.code.toLowerCase(),
//       flag: `https://flagcdn.com/24x18/${item.code.toLowerCase()}.png`,
//     }));

//     setCountryOptions(formattedOptions);
//     setSelectedCountry(formattedOptions[0]);
//     onChange?.({ countryCode: formattedOptions[0].value, phone: "" });

//     getCountryCodes();
//   }, [onChange]);

//   const handleSelectChange = (selectedOption) => {
//     setSelectedCountry(selectedOption);
//     onChange?.({ countryCode: selectedOption.value, phone });
//   };

//   const handlePhoneChange = (e) => {
//     const value = e.target.value;
//     setPhone(value);
//     onChange?.({ countryCode: selectedCountry?.value || "", phone: value });
//   };

//   return (
//     <div className="form-group country-select_group mb-3">
//       {label && <label>{label}</label>}
//       <div className="country-phone-wrapper">
//         <div className="country-select-wrapper">
//           <Select
//             options={countryOptions}
//             value={selectedCountry}
//             onChange={handleSelectChange}
//             classNamePrefix="country-custom-select"
//             formatOptionLabel={(data, { context }) =>
//               context === "menu" ? (
//                 // ✅ Dropdown menu: Show flag + country + dial code
//                 <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                   <img
//                     src={data.flag}
//                     alt={data.code}
//                     width={20}
//                     height={15}
//                     style={{ borderRadius: "2px", objectFit: "cover" }}
//                   />
//                   <span>{data.label}</span>
//                 </div>
//               ) : (
//                 // ✅ After selection: show only dial code like "+91"
//                 <span>{data.value}</span>
//               )
//             }
//           />
//         </div>
//         <input
//           type="tel"
//           className="country-phone-input"
//           placeholder="Enter phone number"
//           value={phone}
//           onChange={handlePhoneChange}
//         />
//       </div>
//     </div>
//   );
// };

// export default CountryCode;